import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

export interface IncomeRequest {
  id: string;
  userId: string;
  status: "pending" | "approved" | "declined";
  amount: number;
  approvedAmount: number | null;
  concept: string;
  categoryId: string | null;
  observations: string | null;
  image: string | null;
  reviewNotes: string | null;
  createdAt: string;
  reviewedAt: string | null;
  requestedBy: { id: string; firstName: string; lastName: string; email: string } | null;
  reviewedBy: { id: string; firstName: string; lastName: string; email: string } | null;
}

@Injectable({ providedIn: "root" })
export class IncomeRequestsService {
  private readonly base = `${environment.apiUrl}/income-requests`;

  constructor(private readonly http: HttpClient) {}

  create(data: FormData) {
    return this.http.post<IncomeRequest>(this.base, data);
  }

  list(status?: string) {
    const params = status ? `?status=${status}` : "";
    return this.http.get<IncomeRequest[]>(`${this.base}${params}`);
  }

  countPending() {
    return this.http.get<{ count: number }>(`${this.base}/count`);
  }

  approve(id: string, data?: { approvedAmount?: number; categoryId?: string; reviewNotes?: string }) {
    return this.http.patch<IncomeRequest>(`${this.base}/${id}/approve`, data ?? {});
  }

  decline(id: string, reviewNotes?: string) {
    return this.http.patch<IncomeRequest>(`${this.base}/${id}/decline`, { reviewNotes });
  }
}
